if (!customElements.get('dl-product-page')) {
  customElements.define('dl-product-page', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.querySelectorAll('[data-pdp-anchor]').forEach(link => {
        link.addEventListener('click', event => {
          const target = this.querySelector(link.getAttribute('href'));
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView({ block: 'start', behavior: 'auto' });
          if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
          target.focus({ preventScroll: true });
        });
      });
      this.querySelectorAll('[data-pdp-open]').forEach(button => {
        button.addEventListener('click', () => {
          const dialog = this.querySelector('#' + button.dataset.pdpOpen);
          if (!dialog) return;
          dialog.showModal();
          const reader = dialog.querySelector('dl-guide-preview');
          if (typeof reader?.selectSample === 'function') reader.selectSample(button.dataset.pdpSample || '1');
        });
      });
      this.querySelectorAll('dialog').forEach(dialog => {
        dialog.querySelector('[data-pdp-close]')?.addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        });
      });
    }
  });
}
